window.vf.enterpriseShopChat = (function () {
    'use strict';

    const GENESYS_WIDGET_URL = '/business/genesys/';

    const GENESYS_CHAT_OPEN_CMD = 'WebChat.open';
    const GENESYS_CHAT_STOP_CMD = 'WebChat.endChat';
    const GENESYS_CHAT_CLOSE_CMD = 'WebChat.close';
    const GENESYS_CHAT_MINIMIZE_CMD = 'WebChat.minimize';

    const GENESYS_CHAT_OPENED_SUBSCRIPTION = 'WebChat.opened';
    const GENESYS_CHAT_COMPLETED_SUBSCRIPTION = 'WebChat.completed';
    const GENESYS_CHAT_CANCELLED_SUBSCRIPTION = 'WebChat.cancelled';

    const GENESYS_CHAT_BUTTON = '.business-shop-chat-cta';
    const GENESYS_CHAT_CONTENT = '.business-shop-chat-content';
    const GENESYS_CHAT_RECALL_CONTENT = '.business-shop-chat-recall-content';

    var CXBus;
    var chat;
    var isChatActive;
    var chatAvailable = false;

    function setChatButtonLabel() {
        const chatLabel = isChatActive ? 'Chat schließen' : 'Jetzt chatten';
        if (document.querySelector(GENESYS_CHAT_BUTTON)) {
            document.querySelector(GENESYS_CHAT_BUTTON).innerHTML = chatLabel;
        }
    }

    function openChat () {
        chat.command(GENESYS_CHAT_OPEN_CMD);
    }

    function closeChat() {
        chat.command(GENESYS_CHAT_STOP_CMD);
        chat.command(GENESYS_CHAT_CLOSE_CMD);
    }

    function track () {

        var chatStatus = isChatActive ? 'opened' : 'closed';

        /* eslint-disable no-underscore-dangle */
        var _ddq = window._ddq || (window._ddq = []);
        /* eslint-enable no-underscore-dangle */

        _ddq.push(['notification', {
            'type': 'notification',
            'message': 'Chat ' + chatStatus,
        }]);

    }

    function handleChat() {
        if (chat) {
            (!isChatActive) ?
                openChat() :
                closeChat();
        }
    }

    function chatButtonEventListener () {
        const chatButton = document.querySelector(GENESYS_CHAT_BUTTON);
        chatButton.addEventListener('click', function(e) {
            e.preventDefault();
            handleChat();
        });
    }

    function handleChatButton () {
        setChatButtonLabel();
        chatButtonEventListener();
    }

    function setChat () {

        if (!window.CXBus) {
            setTimeout(function() {
                setChat();
            }, 100);
            return;
        }

        CXBus = window.CXBus;
        chat = CXBus.registerPlugin('EnterpriseShopChat');

        if (chat) {
            chat.subscribe(GENESYS_CHAT_OPENED_SUBSCRIPTION, function() {
                isChatActive = true;
                setChatButtonLabel();
                track();
            });

            chat.subscribe(GENESYS_CHAT_COMPLETED_SUBSCRIPTION, function() {
                isChatActive = false;
                setChatButtonLabel();
                track();
            });

            chat.subscribe(GENESYS_CHAT_CANCELLED_SUBSCRIPTION, function() {
                isChatActive = false;
                chat.command(GENESYS_CHAT_CLOSE_CMD);
                chat.command(GENESYS_CHAT_MINIMIZE_CMD);
                setChatButtonLabel();
                track();
            });
        }

        handleChatButton();

    }

    function handleFlyoutContent() {
        const chatContent = document.querySelector(GENESYS_CHAT_CONTENT);
        const recallContent = document.querySelector(GENESYS_CHAT_RECALL_CONTENT);

        if (!chatAvailable) {
            if (chatContent) {
                chatContent.style.display = 'none';
            }
            if (recallContent) {
                recallContent.style.display = 'block';
            }
        } else {
            if (chatContent) {
                chatContent.style.display = 'block';
            }
            if (recallContent) {
                recallContent.style.display = 'none';
            }
        }

    }

    function initChat() {

        /* eslint-disable no-underscore-dangle */

        if (!window._genesys) {window._genesys = {};}
        if (!window._gt) {window._gt = [];}

        window._genesys.widgets = {
            main: {
                debug: false,
                theme: 'light',
                mobileMode: 'auto',
                i18n: '/business/shop/widgets-de-shop-i18n.json',
                lang: 'de',
                themes: {
                    vodafone: 'cx-theme-light cx-theme-vodafone-shop',
                },
            },
            webchat: {
                emojis: true,
                pollExceptionLimit: 15,
                restoreTimeout: 60000,
                uploadsEnabled: false,
                confirmFormCloseEnabled: true,
                actionsMenu: true,
                timeFormat: 24,
                autoInvite: {
                    enabled: false,
                    timeToInviteSeconds: 5,
                    inviteTimeoutSeconds: 30,
                },
                dataURL: 'https://eweb8.vfd2-testnet.de/gms/chat/b2b',
                userData: {selectedTopic: 'b2b'},
                form: {
                    wrapper: '<table></table>',
                    inputs: [

                        {
                            id: 'cx_webchat_form_firstname',
                            name: 'firstname',
                            maxlength: '100',
                            placeholder: 'Vorname',
                            label: 'Vorname'
                        },

                        {
                            id: 'cx_webchat_form_lastname',
                            name: 'lastname',
                            maxlength: '100',
                            placeholder: 'Nachname',
                            label: 'Nachname'
                        },

                        {
                            id: 'cx_webchat_form_issue',
                            type: 'select',
                            name: 'issue',
                            label: 'Anliegen',
                            placeholder: 'Anliegen',
                            options: [
                                {text: 'Produkt- & Tarifberatung', value: 'Produkt- & Tarifberatung'},
                                {text: 'Hilfe & Service', value: 'Hilfe & Service'}
                            ]
                        },

                        {
                            id: 'cx_webchat_form_privacy',
                            type: 'checkbox',
                            name: 'privacy',
                            label: 'Ich habe den Datenschutzhinweis zur Kenntnis genommen und stimme diesem zu.',
                            required: true,
                            wrapper: '<tr><td colspan="2"><div class="cx-checkbox">{input}{label}</div></div><a href="/unternehmen/soziale-verantwortung/datenschutz-privatsphaere.html" target="_blank">Datenschutzerklärung</a></td></tr>',
                            checked: false,
                            validate: function (event, form, input, label) {
                                if (input) {
                                    if (input.val() && input[0].checked) {
                                        label[0].innerHTML = 'Ich habe den Datenschutzhinweis zur Kenntnis genommen und stimme diesem zu.';
                                        return true;
                                    } else {
                                        label[0].innerHTML = '<span style=\"color:red\">Ich habe den Datenschutzhinweis zur Kenntnis genommen und stimme diesem zu.</span>';
                                        return false;
                                    }
                                } else {
                                    // first load
                                    return false;
                                }
                            }
                        }
                    ]
                }
            },
        };

        window._genesys.widgets.main.theme = 'vodafone';

        /* eslint-enable no-underscore-dangle */

        const widgetScriptElement = document.createElement('script');
        widgetScriptElement.setAttribute('src', GENESYS_WIDGET_URL + 'cxbus.min.js');
        widgetScriptElement.addEventListener('load', function() {
            window.CXBus.configure({debug: false, pluginsPath: '/business/genesys/plugins/'});
            window.CXBus.loadPlugin('widgets-core');
        });
        document.body.appendChild(widgetScriptElement);

    }

    function init() {
        var response = null;
        $.ajax({
            type: 'GET',
            url: 'https://eweb8.vfd2-testnet.de/gmchat/service/agent-availability-v2?_media=b2b_chat',
            dataType: 'json',
            async: false
        }).done( function (data) {
            response = JSON.stringify(data);
            response = JSON.parse(response);
            chatAvailable = response.Available;
            handleFlyoutContent();
            if (chatAvailable) {
                initChat();
                setChat();
            }
        }).fail( function() {
            handleFlyoutContent();
            console.log('B2B Chat availability service fail');
        });

    }

    return {
        'init': init
    };
})();
